function MsgInfo({ msg }) {
  if (!msg) return null;
  return <div className="text-neutral-600 text-lg py-2 px-4">{msg}</div>;
}

export default MsgInfo;
